import { deleteEdge } from "../functions/deleteEdge";
import { WhatsappTemplateButtonTypeEnum } from "../enums";
import { WhatsappTemplateCategoryEnum } from "../enums";
export async function handleShouldBeReplaced(
  shouldBeReplaced,
  nodes,
  edges,
  selectedTemplate,
  setNodes,
  setEdges,
  api,
  oldSelectedNode,
) {
  const updatedNodes = [...nodes];
  const selectedNode = updatedNodes.find((n) => n.selected) ?? oldSelectedNode;

  const edgesToUpdate = edges
    .filter(
      (e) =>
        e.source === selectedNode?.id &&
        e.sourceHandle !== "main" &&
        e.sourceHandle !== "",
    )
    .sort((b, a) => (b.sourceHandle ?? "").localeCompare(a.sourceHandle ?? ""));

  const checkVariableOnUrlInCards = (carousel, handleIds, handlesToDelete) => {
    let globalButtonIndex = 0;

    carousel?.cards?.forEach((card) => {
      const buttonsComponent = card.components?.find(
        (c) => c.type === "BUTTONS",
      );

      if (!buttonsComponent?.buttons?.length) return;

      buttonsComponent.buttons.forEach((btn) => {
        const currentHandle = handleIds[globalButtonIndex];

        const isUrlType =
          btn.type === WhatsappTemplateButtonTypeEnum.URL || btn.type === "url";

        const hasVariable = !btn.url?.includes("redirect");

        if (isUrlType && hasVariable) {
          handlesToDelete.push(currentHandle);
        }

        globalButtonIndex++;
      });
    });
  };

  if (selectedTemplate) {
    var newButtonsCount = selectedTemplate?.components
      .filter((component) => component.type === "BUTTONS")
      .reduce(
        (total, component) =>
          total +
          (component.buttons?.filter(
            (button) =>
              button.type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY,
          ).length || 0),
        0,
      );
  }
  if (newButtonsCount === 0 || !newButtonsCount) {
    newButtonsCount = 0;
  }

  if (edgesToUpdate.length > 0) {
    if (!selectedTemplate) {
      for (const e of edgesToUpdate) {
        await deleteEdge(e, setEdges, api, edges);
      }
    }
    if (oldSelectedNode?.cards) {
      if (
        selectedTemplate?.components?.find(
          (c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL,
        )
      ) {
        const oldCarouselHasOneButton =
          oldSelectedNode?.cards[0]?.components
            .find((c) => c.type === "BUTTONS")
            ?.buttons.filter(
              (button) =>
                button.type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY ||
                button.type === WhatsappTemplateButtonTypeEnum.URL,
            ).length === 1;

        const newCarouselHasOneButton =
          selectedTemplate?.components
            ?.find((c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL)
            ?.cards[0]?.components.find((c) => c.type === "BUTTONS")
            ?.buttons.filter(
              (button) =>
                button.type === WhatsappTemplateButtonTypeEnum.QUICK_REPLY ||
                button.type === WhatsappTemplateButtonTypeEnum.URL,
            ).length === 1;

        if (
          oldSelectedNode?.cards?.length >
          selectedTemplate?.components?.find(
            (c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL,
          ).cards.length
        ) {
          const handleIds = [];
          for (let i = 0; i < 20; i++) {
            handleIds.push(String.fromCharCode(97 + i));
          }
          const oldCount = oldSelectedNode.cards.length;
          const newCount = selectedTemplate?.components?.find(
            (c) => c.type === "CAROUSEL",
          )?.cards.length;

          const handlesToDelete = [];
          for (let i = newCount; i < oldCount; i++) {
            handlesToDelete.push(handleIds[i * 2], handleIds[i * 2 + 1]);
          }

          for (const e of edgesToUpdate) {
            if (handlesToDelete.includes(e.sourceHandle)) {
              await deleteEdge(e, setEdges, api, edges);
            }
          }
        }
        if (!oldCarouselHasOneButton && newCarouselHasOneButton) {
          const handleIds = [];
          for (let i = 0; i < 20; i++) {
            handleIds.push(String.fromCharCode(97 + i));
          }
          const newCount = selectedTemplate?.components?.find(
            (c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL,
          )?.cards.length;

          const handlesToDelete = [];
          for (let i = 0; i < newCount; i++) {
            handlesToDelete.push(handleIds[i * 2 + 1]);
          }
          const carousel = selectedTemplate?.components?.find(
            (c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL,
          );
          if (carousel?.cards) {
            await checkVariableOnUrlInCards(
              carousel,
              handleIds,
              handlesToDelete,
            );
          }
          for (const e of edgesToUpdate) {
            if (handlesToDelete.includes(e.sourceHandle)) {
              await deleteEdge(e, setEdges, api);
            }
          }
        }
        if (
          (oldCarouselHasOneButton && newCarouselHasOneButton) ||
          (!oldCarouselHasOneButton && !newCarouselHasOneButton)
        ) {
          const handleIds = [];
          for (let i = 0; i < 20; i++) {
            handleIds.push(String.fromCharCode(97 + i));
          }

          const carousel = selectedTemplate?.components?.find(
            (c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL,
          );
          const handlesToDelete = [];

          if (carousel?.cards) {
            await checkVariableOnUrlInCards(
              carousel,
              handleIds,
              handlesToDelete,
            );
          }
          for (const e of edgesToUpdate) {
            if (handlesToDelete.includes(e.sourceHandle)) {
              await deleteEdge(e, setEdges, api);
            }
          }
        }
      } else {
        for (const e of edgesToUpdate) {
          await deleteEdge(e, setEdges, api);
        }
      }
    } else {
      if (
        selectedTemplate?.components?.find(
          (c) => c.type === WhatsappTemplateCategoryEnum.CAROUSEL,
        )
      ) {
        for (const e of edgesToUpdate) {
          await deleteEdge(e, setEdges, api);
        }
      } else {
        const buttonsComponent = selectedTemplate?.components.find(
          (c) => c.type === "BUTTONS",
        );
        const urlButtons = buttonsComponent?.buttons?.filter(
          (b) => b.type === WhatsappTemplateButtonTypeEnum.URL,
        );
        const newFirstUrlButton = urlButtons?.[0];
        const newSecondUrlButton = urlButtons?.[1];
        if (oldSelectedNode?.urlButton) {
          for (const e of edgesToUpdate) {
            if (
              (e.sourceHandle === "urlA" && !newFirstUrlButton) ||
              (e.sourceHandle === "urlA" &&
                newFirstUrlButton &&
                !newFirstUrlButton?.url.includes("redirect"))
            ) {
              await deleteEdge(e, setEdges, api);
            }
          }
        }
        if (oldSelectedNode?.urlButton2) {
          for (const e of edgesToUpdate) {
            if (
              (e.sourceHandle === "urlB" && !newSecondUrlButton) ||
              (e.sourceHandle === "urlB" &&
                newSecondUrlButton &&
                !newSecondUrlButton?.url.includes("redirect"))
            ) {
              await deleteEdge(e, setEdges, api);
            }
          }
        }
        if (oldSelectedNode?.buttons?.length > 0) {
          const validHandles = ["a", "b", "c"];
          const edgesOnButton = edgesToUpdate.filter((e) =>
            validHandles.includes(e.sourceHandle),
          );
          let handlesToKeep = [];
          if (newButtonsCount === 1) {
            handlesToKeep = ["a"];
          } else if (newButtonsCount === 2) {
            handlesToKeep = ["a", "b"];
          } else if (newButtonsCount >= 3) {
            handlesToKeep = ["a", "b", "c"];
          }

          const edgesToDelete = edgesOnButton.filter(
            (e) => !handlesToKeep.includes(e.sourceHandle),
          );

          for (const e of edgesToDelete) {
            await deleteEdge(e, setEdges, api);
          }
        }
      }
    }
  }

  if (selectedNode?.data) {
    selectedNode.data.shouldBeReplaced = shouldBeReplaced;
  }
  setNodes(updatedNodes);
}
